import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useMyGames } from "@seabrookstudios/pitch2table";
import { showAlarm } from "@seabrookstudios/pitch2table-core";
import { GameListEntry2 } from "../games/ListItem";
import { Path } from "../Path";

export const FollowUpsCard = () => {
  const { data: games = [], isLoading } = useMyGames();

  const gamesWithFollowUps = games.filter((game) => game.nextAction && showAlarm(game.nextAction));

  if (isLoading) {
    return null;
  }

  if (gamesWithFollowUps.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader title="Follow Ups Due" subheader="These games require your attention" />
      <CardContent>
        <List dense>
          {gamesWithFollowUps.map((game) => (
            <ListItem key={game.id}>
              <GameListEntry2 item={game} noAlert={false} link={Path.game(game.id).publishers()} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
